/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { JoinOptionsSection } from '../JoinOptionsSection/JoinOptionsSection';
import { DividerWithText } from '../../../Divider/DividerWithText';
import { InstantJoinOption } from '../JoinOptionsSection/JoinOptions/InstantJoinOption';
import { NativeStartJoinOption } from '../JoinOptionsSection/JoinOptions/NativeStartJoinOption';

interface Props {
  onStartButtonClick: () => void;
}

const messages = defineMessages({
  heading: {
    id: 'secondJoinManualNativeIJ.heading',
  },
  conjunction: {
    id: 'secondJoinManualNativeIJ.conjunction',
  },
});

export const SecondJoinManualNativeIJ: React.FC<Props> = (props) => {
  const { onStartButtonClick } = props;
  const { formatMessage: f } = useIntl();

  return (
    <JoinOptionsSection
      id='secondJoinManualNativeIJ'
      heading={f(messages.heading)}
      options={2}
    >
      <InstantJoinOption />
      <DividerWithText
        conjunction={f(messages.conjunction)}
        orientation='vertical'
      />
      <NativeStartJoinOption onStartButtonClick={onStartButtonClick} />
    </JoinOptionsSection>
  );
};
